import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { Restaurant } from '../types/entities/Restaurant';
import { BooleanField } from '../components/Table/fields/BooleanField';

export const restaurant: SchemaWithClient<Restaurant> = {
  name: 'Restaurant',
  pluralName: 'Restaurant',
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    hood: {
      name: 'Hood',
      fieldRenderer: TextField,
      fieldType: 'textarea',
    },
    address: {
      name: 'Address',
      fieldRenderer: TextField,
      fieldType: 'textarea',
    },
    kitchen: {
      name: 'Kitchen',
      fieldRenderer: TextField,
      fieldType: 'textarea',
    },
    elegant: {
      name: 'Elegant',
      fieldRenderer: BooleanField,
      fieldType: 'boolean',
    },
    outdoor: {
      name: 'Outdoor',
      fieldRenderer: BooleanField,
      fieldType: 'boolean',
    },
    discount_menu: {
      name: 'Discount Menu',
      fieldRenderer: TextField,
      fieldType: 'textarea',
    },
    discount: {
      name: 'Discount',
      fieldRenderer: TextField,
      fieldType: 'textarea',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/restaurants'),
};
